// Asset to Feature Mappings
// Only includes assets that exist in public/Games/icons/*.png
// Names use proper spacing, imagePath uses the actual filename

export const FEATURE_ASSET_MAPPINGS = {
  'Are sticky': [
    { name: 'Glue', imagePath: 'glue' },
    { name: 'Honey', imagePath: 'honey' },
    { name: 'Tape', imagePath: 'tape' },
  ],

  'Have a handle': [
    { name: 'School Bag', imagePath: 'schoolbag' },
    { name: 'Toothbrush', imagePath: 'toothbrush' },
    { name: 'Cup', imagePath: 'cup' },
    { name: 'Spoon', imagePath: 'spoon' },
    { name: 'Door', imagePath: 'door' },
    { name: 'Fork', imagePath: 'fork' },
    { name: 'Knife', imagePath: 'knife' },
    { name: 'Hammer', imagePath: 'hammer' },
    { name: 'Screwdriver', imagePath: 'screwdriver' },
    { name: 'Saw', imagePath: 'saw' },
    { name: 'Pan', imagePath: 'pan' },
    { name: 'Pot', imagePath: 'pot' },
  ],

  'Are cold': [
    { name: 'Ice Cream', imagePath: 'icecream' },
    { name: 'Snow', imagePath: 'snow' },
    { name: 'Ice', imagePath: 'ice' },
  ],

  'Are hot': [
    { name: 'Sunny', imagePath: 'sunny' },
    { name: 'Fire', imagePath: 'fire' },
    { name: 'Oven', imagePath: 'oven' },
  ],

  'Have wings': [
    { name: 'Airplane', imagePath: 'airplane' },
    { name: 'Butterfly', imagePath: 'butterfly' },
    { name: 'Eagle', imagePath: 'eagle' },
    { name: 'Dragonfly', imagePath: 'dragonfly' },
    { name: 'Bee', imagePath: 'bee' },
    { name: 'Wasp', imagePath: 'wasp' },
    { name: 'Owl', imagePath: 'owl' },
    { name: 'Parrot', imagePath: 'parrot' },
    { name: 'Penguin', imagePath: 'penguin' },
    { name: 'Robin', imagePath: 'robin' },
  ],

  'Have wheels': [
    { name: 'Car', imagePath: 'car' },
    { name: 'Airplane', imagePath: 'airplane' },
    { name: 'Bike', imagePath: 'bike' },
    { name: 'Scooter', imagePath: 'scooter' },
    { name: 'Skateboard', imagePath: 'skateboard' },
    { name: 'Bus', imagePath: 'bus' },
    { name: 'Truck', imagePath: 'truck' },
    { name: 'Van', imagePath: 'van' },
    { name: 'Train', imagePath: 'train' },
  ],

  'Have a seat': [
    { name: 'Bike', imagePath: 'bike' },
    { name: 'Bus', imagePath: 'bus' },
    { name: 'Chair', imagePath: 'chair' },
    { name: 'Sofa', imagePath: 'sofa' },
    { name: 'Stool', imagePath: 'stool' },
    { name: 'Bench', imagePath: 'bench' },
  ],

  'Have letters': [
    { name: 'Book', imagePath: 'book' },
    { name: 'Keyboard', imagePath: 'keyboard' },
    { name: 'Newspaper', imagePath: 'newspaper' },
    { name: 'Magazine', imagePath: 'magazine' },
  ],

  'Have numbers': [
    { name: 'Keyboard', imagePath: 'keyboard' },
    { name: 'Calculator', imagePath: 'calculator' },
    { name: 'Stopwatch', imagePath: 'stopwatch' },
    { name: 'Clock', imagePath: 'clock' },
  ],

  'Are sweet': [
    { name: 'Ice Cream', imagePath: 'icecream' },
    { name: 'Lollipop', imagePath: 'lollipop' },
    { name: 'Honey', imagePath: 'honey' },
    { name: 'Marshmallow', imagePath: 'marshmallow' },
    { name: 'Brownie', imagePath: 'brownie' },
    { name: 'Mango', imagePath: 'mango' },
    { name: 'Strawberry', imagePath: 'strawberry' },
    { name: 'Cherries', imagePath: 'cherries' },
  ],

  'Have pages': [
    { name: 'Newspaper', imagePath: 'newspaper' },
    { name: 'Magazine', imagePath: 'magazine' },
    { name: 'Book', imagePath: 'book' },
    { name: 'Catalogue', imagePath: 'catalogue' },
  ],

  'Have legs': [
    { name: 'Table', imagePath: 'table' },
    { name: 'Chair', imagePath: 'chair' },
    { name: 'Bed', imagePath: 'bed' },
    { name: 'Fox', imagePath: 'fox' },
    { name: 'Person', imagePath: 'person' },
    { name: 'Dog', imagePath: 'dog' },
    { name: 'Cat', imagePath: 'cat' },
    { name: 'Horse', imagePath: 'horse' },
    { name: 'Cow', imagePath: 'cow' },
    { name: 'Pig', imagePath: 'pig' },
    { name: 'Sheep', imagePath: 'sheep' },
    { name: 'Stool', imagePath: 'stool' },
    { name: 'Bench', imagePath: 'bench' },
    { name: 'Owl', imagePath: 'owl' },
    { name: 'Parrot', imagePath: 'parrot' },
    { name: 'Eagle', imagePath: 'eagle' },
    { name: 'Robin', imagePath: 'robin' },
    { name: 'Penguin', imagePath: 'penguin' },
  ],

  'Are crunchy': [
    { name: 'Chips', imagePath: 'chips' },
    { name: 'Cookies', imagePath: 'cookies' },
    { name: 'Cracker', imagePath: 'cracker' },
  ],

  'Have a screen': [
    { name: 'iPad', imagePath: 'ipad' },
    { name: 'Laptop', imagePath: 'laptop' },
    { name: 'iPhone', imagePath: 'iphone' },
    { name: 'TV', imagePath: 'tv' },
  ],

  'Have a tail': [
    { name: 'Dog', imagePath: 'dog' },
    { name: 'Cat', imagePath: 'cat' },
    { name: 'Mouse', imagePath: 'mouse' },
    { name: 'Giraffe', imagePath: 'giraffe' },
    { name: 'Fox', imagePath: 'fox' },
    { name: 'Horse', imagePath: 'horse' },
    { name: 'Cow', imagePath: 'cow' },
    { name: 'Pig', imagePath: 'pig' },
    { name: 'Sheep', imagePath: 'sheep' },
    { name: 'Lion', imagePath: 'lion' },
    { name: 'Tiger', imagePath: 'tiger' },
    { name: 'Zebra', imagePath: 'zebra' },
  ],

  'Have a beak': [
    { name: 'Owl', imagePath: 'owl' },
    { name: 'Penguin', imagePath: 'penguin' },
    { name: 'Parrot', imagePath: 'parrot' },
    { name: 'Eagle', imagePath: 'eagle' },
    { name: 'Robin', imagePath: 'robin' },
  ],

  'Have feathers': [
    { name: 'Owl', imagePath: 'owl' },
    { name: 'Parrot', imagePath: 'parrot' },
    { name: 'Eagle', imagePath: 'eagle' },
    { name: 'Robin', imagePath: 'robin' },
    { name: 'Penguin', imagePath: 'penguin' },
  ],

  'Have fur': [
    { name: 'Dog', imagePath: 'dog' },
    { name: 'Fox', imagePath: 'fox' },
    { name: 'Cat', imagePath: 'cat' },
    { name: 'Hamster', imagePath: 'hamster' },
    { name: 'Mouse', imagePath: 'mouse' },
    { name: 'Sheep', imagePath: 'sheep' },
    { name: 'Lion', imagePath: 'lion' },
    { name: 'Tiger', imagePath: 'tiger' },
    { name: 'Zebra', imagePath: 'zebra' },
    { name: 'Giraffe', imagePath: 'giraffe' },
  ],

  'Have sharp teeth': [
    { name: 'Shark', imagePath: 'shark' },
    { name: 'Tiger', imagePath: 'tiger' },
    { name: 'Lion', imagePath: 'lion' },
  ],

  'Are long': [
    { name: 'Cable', imagePath: 'cable' },
    { name: 'Rope', imagePath: 'rope' },
    { name: 'String', imagePath: 'string' },
  ],

  'Are sharp': [
    { name: 'Knife', imagePath: 'knife' },
    { name: 'Scissors', imagePath: 'scissor' },
    { name: 'Saw', imagePath: 'saw' },
    { name: 'Nail', imagePath: 'nail' },
  ],

  'Have a zipper': [
    { name: 'Pencil Case', imagePath: 'pencilcase' },
    { name: 'Jeans', imagePath: 'jeans' },
    { name: 'School Bag', imagePath: 'schoolbag' },
    { name: 'Jacket', imagePath: 'jacket' },
  ],

  'Have sleeves': [
    { name: 'Dress', imagePath: 'dress' },
    { name: 'Shirt', imagePath: 'shirt' },
    { name: 'Jacket', imagePath: 'jacket' },
    { name: 'Raincoat', imagePath: 'raincoat' },
    { name: 'Coat', imagePath: 'coat' },
  ],

  'Have seeds': [
    { name: 'Mango', imagePath: 'mango' },
    { name: 'Cherries', imagePath: 'cherries' },
    { name: 'Strawberry', imagePath: 'strawberry' },
    { name: 'Apple', imagePath: 'apple' },
  ],

  'Are soft': [
    { name: 'Marshmallow', imagePath: 'marshmallow' },
    { name: 'Tissue', imagePath: 'tissue' },
    { name: 'Blanket', imagePath: 'blanket' },
    { name: 'Towel', imagePath: 'towel' },
    { name: 'Sponge', imagePath: 'sponge' },
  ],

  'Are round': [
    { name: 'Ball', imagePath: 'ball' },
    { name: 'Tape', imagePath: 'tape' },
    { name: 'Circle', imagePath: 'circle' },
    { name: 'Clock', imagePath: 'clock' },
    { name: 'Stopwatch', imagePath: 'stopwatch' },
    { name: 'Cookies', imagePath: 'cookies' },
    { name: 'Cherries', imagePath: 'cherries' },

  ],

  'Have a stinger': [
    { name: 'Scorpion', imagePath: 'scorpion' },
    { name: 'Bee', imagePath: 'bee' },
    { name: 'Wasp', imagePath: 'wasp' },
  ],

  'Are red': [
    { name: 'Tomato', imagePath: 'tomato' },
    { name: 'Circle', imagePath: 'circle' },
    { name: 'Strawberry', imagePath: 'strawberry' },
    { name: 'Apple', imagePath: 'apple' },
    { name: 'Scooter', imagePath: 'scooter' },
    { name: 'Blood', imagePath: 'blood' },
    { name: 'Book', imagePath: 'book' },
    { name: 'Car', imagePath: 'car' },
    { name: 'Rose', imagePath: 'rose' },
    { name: 'Jacket', imagePath: 'jacket' },
    { name: 'Heart', imagePath: 'heart' },
    { name: 'Cherries', imagePath: 'cherries' },
  ],
};

// Helper function to get all features
export function getAllFeatures() {
  return Object.keys(FEATURE_ASSET_MAPPINGS);
}

// Helper function to get assets for a specific feature
export function getAssetsForFeature(featureName) {
  return FEATURE_ASSET_MAPPINGS[featureName] || [];
}

// Helper function to get all unique assets across all features
export function getAllFeatureAssets() {
  const allAssets = new Map();
  Object.values(FEATURE_ASSET_MAPPINGS).forEach(assets => {
    assets.forEach(asset => {
      allAssets.set(asset.imagePath, asset);
    });
  });
  return Array.from(allAssets.values());
}

// Helper function to convert to the format expected by Game 3/4
export function convertToGame3Format() {
  return Object.entries(FEATURE_ASSET_MAPPINGS)
    .filter(([feature, assets]) => assets.length >= 3) // Only features with 3+ items
    .map(([feature, assets]) => ({
      feature,
      correct: assets.map(asset => asset.imagePath)
    }));
}

// Helper function to find what feature(s) an asset has
export function getFeaturesForAsset(imagePath) {
  const features = [];
  Object.entries(FEATURE_ASSET_MAPPINGS).forEach(([featureName, assets]) => {
    if (assets.some(asset => asset.imagePath === imagePath)) {
      features.push(featureName);
    }
  });
  return features;
}
